<template>
  <guest-card>
    <div class="row">
      <div class="col-lg-6 d-none d-lg-block bg-password-image"></div>
      <div class="col-lg-6">
        <div class="p-5">
          <div class="text-center d-flex justify-content-center mb-4">
            <img
              src="assets/img/KMUTT60yrEng.png"
              class="img-fluid"
              style="height:120px"
            />
            <img
              src="assets/img/Eng60yr.png"
              class="img-fluid"
              style="height:120px"
            />
          </div>
          <div class="text-center">
            <h1 class="h4 text-gray-900 mb-2">Forgot Your Password?</h1>
            <p class="mb-4">
              We get it, stuff happens. Just enter your email address below and
              we'll send you a link to reset your password!
            </p>
          </div>
          <form class="user" @submit.prevent="onSubmit">
            <div class="form-group">
              <input
                type="email"
                v-model="form.username"
                class="form-control form-control-user"
                aria-describedby="emailHelp"
                placeholder="Enter Email Address..."
              />
            </div>
            <button type="submit" class="btn btn-primary btn-user btn-block">
              Reset Password
            </button>
          </form>
          <hr />
          <div class="text-center">
            <router-link class="small" to="register"
            >Create an Account!
            </router-link
            >
          </div>
          <div class="text-center">
            <router-link class="small" to="company/register"
            >Already have an account? Login!
            </router-link
            >
          </div>
        </div>
      </div>
    </div>
  </guest-card>
</template>

<script>
import guestCard from "@/components/cards/guestCard";
export default {
  title: "Job Fair Faculty of Engineering - Reset password",
  name: "resetPassword",
  components: {
    guestCard
  },
  data() {
    return {
      form: {
        username: ""
      },
      show: true
    };
  },
  methods: {
    onSubmit() {
      this.$store
        .dispatch("resetpass", this.form)
        .then(() => {
          this.$router.push({path: "/company/login"});
        })
        .catch(err => {
          console.log(`Reset Password Error: ${err}`);
        });
    }
  }
};
</script>
